import { useState } from 'react';
import {
  DebitOrderClient,
  CreateDebitOrderMandateRequestDTO,
  UpdateDebitOrderMandateRequestDTO,
} from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useDebitOrderMandateApi = () => {
  const apiClient = new DebitOrderClient(API_BASE_URL, axiosInstance);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createMandate = async (data: CreateDebitOrderMandateRequestDTO) => {
    setIsLoading(true);
    try {
      return await apiClient.createDebitOrderMandate(data);
    } catch (err: any) {
      setError(err.message || 'Error creating debit order mandate');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const getMandatesByMember = async (memberId: string) => {
    setIsLoading(true);
    try {
      return await apiClient.getMandatesByMember(memberId);
    } catch (err: any) {
      setError(err.message || 'Error fetching mandates');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const getMandateById = async (mandateId: string) => {
    setIsLoading(true);
    try {
      return await apiClient.getDebitOrderMandateById(mandateId);
    } catch (err: any) {
      setError(err.message || 'Error fetching mandate');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const getMandateFormData = async (invoiceId: string) => {
    setIsLoading(true);
    try {
      return await apiClient.getMandateFormData(invoiceId);
    } catch (err: any) {
      setError(err.message || 'Error fetching form data');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const getMandateEditFormData = async (mandateId: string) => {
    setIsLoading(true);
    try {
      return await apiClient.getMandateEditFormData(mandateId);
    } catch (err: any) {
      setError(err.message || 'Error fetching mandate edit data');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const updateMandate = async (mandateId: string, data: UpdateDebitOrderMandateRequestDTO) => {
    setIsLoading(true);
    try {
      return await apiClient.updateDebitOrderMandate(mandateId, data);
    } catch (err: any) {
      setError(err.message || 'Error updating debit order mandate');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    createMandate,
    getMandatesByMember,
    getMandateById,
    getMandateFormData,
    getMandateEditFormData,
    updateMandate,
    isLoading,
    error,
  };
};
